import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_490: DocMigration = {
  maxSchemaVersion: "0.0.490",
  description: "Hide the Tag column for any data tables with a casework data sequence",
  apply(json: any): any {
    for (const id in json.dataTables) {
      const dataTable = json.dataTables[id];
      if (dataTable.dataSequenceId === "CASEWORK") {
        dataTable.columnConfig.tag = {
          isHidden: true,
        };
      }
    }

    return json;
  },
};

export default migration_0_0_490;
